<template>
  <div id="app">
    <inicio-sesion @login="onLogin" v-if="!logeado"/>
    <div v-if="logeado">
      <encabezado-component />
      <app-sidebar />
      <div class="main-content">
        <div class="container mt-3">
          <router-view/>
        </div>
      </div>
    </div>    
  </div>
</template>
<script>
  import EncabezadoComponent from './components/EncabezadoComponent'
  import InicioSesion from './components/Usuarios/InicioSesion'
  import AyudanteSesion from './Servicios/AyudanteSesion'
  import AppSidebar from './components/Extras/Sidebar'

  export default {
    name: "App", 
    components: {
      EncabezadoComponent,
      InicioSesion,
      AppSidebar
    },

    data:()=>({
      logeado: false
    }),

    mounted(){
      const log = AyudanteSesion.verificarSesion()
      this.logeado = log
      console.log(this.logeado)
    },

    methods: {
      onLogin(resultado){
        console.log(resultado)
        if(resultado.estado) {
          AyudanteSesion.establecerSesion(resultado.usuario)
          this.logeado = AyudanteSesion.verificarSesion()
        }
      }
    }
  }
</script>
<style>
:root{
  --app-header-base-height: 58px;
  --app-safe-top: env(safe-area-inset-top, 0px);
  --app-header-height: calc(var(--app-header-base-height) + var(--app-safe-top));
}

.navbar.fondo{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1350;
  height: var(--app-header-height);
  min-height: var(--app-header-height);
  max-height: var(--app-header-height);
  padding-top: var(--app-safe-top);
  overflow: visible;
}

.navbar.fondo .navbar-brand,
.navbar.fondo .navbar-start,
.navbar.fondo .navbar-end,
.navbar.fondo .navbar-menu,
.navbar.fondo .navbar-item{
  height: var(--app-header-base-height) !important;
  min-height: var(--app-header-base-height) !important;
}

.navbar.fondo .navbar-item{
  display: flex;
  align-items: center;
}

.navbar.fondo .navbar-brand,
.navbar.fondo .navbar-menu,
.navbar.fondo .navbar-start,
.navbar.fondo .navbar-end{
  align-items: center !important;
}

.main-content{ margin-left:0; padding-top:calc(var(--app-header-height) + 2px); transition: margin-left .22s ease; }

@media (max-width: 768px){
  :root{ --app-header-base-height: 52px; }

  .navbar.fondo .navbar-menu.is-active{
    position: fixed;
    top: var(--app-header-height);
    left: 0;
    right: 0;
    z-index: 1355;
    height: auto !important;
    min-height: auto !important;
    max-height: calc(100vh - var(--app-header-height));
    overflow-y: auto;
    background: #ffffff;
    opacity: 1;
    border-top: 1px solid rgba(15, 23, 42, 0.08);
    box-shadow: 0 14px 28px rgba(15, 23, 42, 0.16);
    padding: .4rem .7rem .8rem;
  }

  /* La regla global fuerza navbar-start/end a 52px — aquí deben crecer para que todo quede junto sin scroll */
  .navbar.fondo .navbar-menu.is-active .navbar-start,
  .navbar.fondo .navbar-menu.is-active .navbar-end{
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
  }

  .navbar.fondo .navbar-menu.is-active .navbar-item{
    display: flex !important;
    flex-direction: column;
    align-items: stretch !important;
    height: auto !important;
    min-height: 0 !important;
    padding: .55rem .6rem !important;
    color: #1f2937;
    border-radius: 10px;
  }

  .navbar.fondo .navbar-menu.is-active .navbar-item:hover{ background: #f6f7fd; }

  .navbar.fondo .navbar-menu.is-active .navbar-item .buttons{ width: 100%; }

  .navbar.fondo .navbar-menu.is-active .button{
    white-space: nowrap;
    width: 100%;
    justify-content: center;
  }

  .navbar.fondo .navbar-menu.is-active .acting-as-label{
    color: #374151 !important;
    margin-right: 0;
    font-size: .82rem;
    margin-bottom: .35rem;
  }
}

@media (min-width: 769px){
  body.sidebar-open .main-content{ margin-left: var(--sidebar-width, 264px); }
  body.sidebar-open .navbar.fondo{ left: var(--sidebar-width, 264px); right: 0; }
}

/* Toasts de Buefy - asegurar que aparezcan por encima de todo */
.b-toaster {
  z-index: 9999 !important;
}

.b-toaster .b-toast {
  z-index: 9999 !important;
}

.b-toast.is-top {
  z-index: 9999 !important;
}
</style>